import React from "react";
import { Icon, type IconComponent } from "../Icon.js";
import type { IconProps } from "../types.js";

export const ArrowRightIcon: IconComponent = (props: IconProps) => (
    <Icon {...props}>{"\ue5c8"}</Icon>
);
ArrowRightIcon.displayName = "ArrowRightIcon";
